import { render, staticRenderFns } from "./MockExam.vue?vue&type=template&id=0a5362a1"
import script from "./MockExam.vue?vue&type=script&lang=js"
export * from "./MockExam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports